import React, {Component} from 'react';
import {EquipmentTalble} from './EquipmentTalble';
import { getAllEquipment,deleteEquipmentById} from '../../util/APIUtils';
import {SESSION_USER,APP_TITLE} from '../../constants';
import Loading from '../../common/Loading';
import NotFound from '../../common/NotFound';
import ServerError from '../../common/ServerError';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';


class Equipment extends Component {
 
 constructor(props) {
        super(props);
        this.state = {
            dataSet:[],
            loading: true,
            deleteId: '',
            show: false
        };
        this.handleClick = this.handleClick.bind(this);
        this.deleteEquipment = this.deleteEquipment.bind(this);
      
 }



 componentDidMount() {
               
                let user = JSON.parse(localStorage.getItem(SESSION_USER));

                getAllEquipment(user.id)
                .then(response => {
                      // console.log(response);
                       this.setState({dataSet:response,loading: false});
                }).catch(error => {
                   if(error.status === 404) {
                        this.setState({
                            notFound: true,
                        });
                    } else {
                        this.setState({
                            serverError: true,
                        });        
                    }
                });

 }

   componentWillMount() {
        document.body.addEventListener('click', this.handleClick);
    }
    handleClick(event) {
        if(event.target.classList.contains('delete')) {
            var id = event.target.getAttribute('data-id');
            this.setState({
                deleteId : id,
                show: true
            });
        }
    }

    deleteEquipment(id){
  deleteEquipmentById(id)
            .then(response => {
                this.setState({ show: false , deleteId: ''});
                window.location.href='/equipments';
            }).catch(error => {
            if(error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });

    }
   

    render(){

        if(this.state.notFound) {
            return <NotFound />;
        }

        if(this.state.serverError) {
            return <ServerError />;
        }

         if(this.state.loading) {
          // return 'Loading...'
           return <Loading />;
        } 
    return (


          <div>
          

       <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor m-b-0 m-t-0">Equipment</h3>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Home</li>
                            <li className="breadcrumb-item active">Equipment</li>
                        </ol>
                    </div>
                    <div className="col-md-7 col-4 align-self-center">
                            
		                        <div className="d-flex m-t-10 justify-content-end">
		                           
			                            <div className="d-flex m-r-20 m-l-10 hidden-md-down">
                                          <a href="/equipment/0" className="btn-rounded btn waves-effect waves-light btn-primary" >Create Equipment</a>   
                                           
			                              
			                            </div>
			                          
		                             
                         
                                 </div>
                    </div>


                    
            
       </div>
               <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                    <EquipmentTalble data={this.state.dataSet} cols={this.tablecol}></EquipmentTalble>
                                    <SweetAlert
                                    show={this.state.show}
                                    title={APP_TITLE}
                                    text="Are you sure you want to delete this Equipment. If not, click Cancel."
                                    icon="warning"
                                    showCancelButton
                                    confirmButtonColor="#1e88e5"
                                    cancelButtonColor="#2f3d4a"
                                    onConfirm={() => {
                                            this.deleteEquipment(this.state.deleteId); 
                                    }}
                                    onCancel={() => this.setState({ show: false, deleteId: '' })}
                                />
                            </div>
                        </div>
                     </div> 
                  </div>   
                  </div>    
          );
  }

    tablecol=[

                    { title: "Id","mData": "id"},
		            { title: "Name" ,"mData": "name"},
                    { title: "Zoho Id" ,"mData": "zohoId"},
		            { title: "Description" ,"mData": "description"},
		            {  
		            	 "mData": "id",
		                  "render": function(data, type, full, meta) {
                            return "<a href='equipment/" + data + "'>Edit</a>";
                          }   
                    },{
            "mData": "id",
            "render": function(data, type, full, meta) {
                return "<a href='javascript:' data-id='"+data+"' class='delete' >Delete</a>";
            }
        }
		    ];


  
}
export default Equipment;